import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const switchContainer = style({
  display: "flex",
  height: primitiveTokens.sizing["6x"],
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  flexShrink: 0
});

export const switchRoot = style({
  width: "44px",
  height: primitiveTokens.sizing["6x"],
  padding: "2px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  borderRadius: "100px",
  position: "relative",
  border: "none",
  outline: "none",
  cursor: "pointer",

  selectors: {
    // Unchecked: focus state
    "&[data-state='unchecked']:focus-visible": {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.default.untoggled,
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      transition: `background-color ${primitiveTokens.transitionDuration.default} linear`,
      willChange: "background-color"
    },

    // Unchecked: hover state
    "&[data-state='unchecked']:not([data-disabled]):hover": {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.hover.untoggled,
      transition: `background-color ${primitiveTokens.transitionDuration.default} linear`,
      willChange: "background-color"
    },

    // Unchecked: disabled state
    '&[data-state="unchecked"][data-disabled]': {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.disabled.untoggled,
      cursor: "default"
    },

    // Unchecked: default state
    '&[data-state="unchecked"]:not([data-disabled])': {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.default.untoggled
    },

    // Checked: focus state
    "&[data-state='checked']:focus-visible": {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.default.toggled,
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      transition: `background-color ${primitiveTokens.transitionDuration.default} linear`,
      willChange: "background-color"
    },

    // Checked: hover state
    "&[data-state='checked']:not([data-disabled]):hover": {
      backgroundColor: semanticThemeTokens.switch.backgroundColor.hover.toggled,
      transition: `background-color ${primitiveTokens.transitionDuration.default} linear`,
      willChange: "background-color"
    },

    // Checked: disabled state
    '&[data-state="checked"][data-disabled]': {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.disabled.toggled,
      cursor: "default"
    },

    // Checked: default state
    '&[data-state="checked"]:not([data-disabled])': {
      backgroundColor:
        semanticThemeTokens.switch.backgroundColor.default.toggled
    }
  }
});

export const switchThumb = style({
  width: primitiveTokens.sizing["5x"],
  height: primitiveTokens.sizing["5x"],
  backgroundColor: semanticThemeTokens.switch.thumb.backgroundColor,
  flexShrink: 0,
  aspectRatio: "1 / 1",
  borderRadius: "9999px",
  transition: "transform 200ms",
  willChange: "transform",
  selectors: {
    "&[data-state='checked']": {
      transform: "translateX(20px)"
    }
  }
});

export const switchLabel = style({
  color: semanticThemeTokens.switch.label.textColor,
  fontSize: primitiveTokens.type.sm,
  lineHeight: primitiveTokens.type.sm,
  padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["0x"]}`,
  cursor: "pointer",
  selectors: {
    [`${switchRoot}[data-disabled] + &`]: {
      cursor: "default",
      color: semanticThemeTokens.switch.label.textcolorDisabled
    }
  }
});
